<template>
	<div class="countryMark" ref="wrapCountry">
		<ul class="countryUl">
			<li v-for="item in countryList" @click.stop.prevent="clickEvent(item.text, item.code)">
				<span class="fl">{{ item.text }}</span>
				<span class="fr">{{ item.code }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
import BScroll from 'better-scroll';
import {countryCode} from '../js/countryData.js';
export default {
	name: 'countrycom',
	data() {
		return {
			countryList: countryCode,
			countryScroll: null
		};
	},
	methods: {
		_innerCountryScroll() {
			this.countryScroll = new BScroll(this.$refs.wrapCountry, {
				scrollY: true,
				click: true,
				starY: 0
			});
		},
		clickEvent(country, code) {
			this.$emit('change', {guojia: country, quhao: code});
		}
	},
	mounted() {
		this._innerCountryScroll();
	}
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.countryMark {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background: #fff;
	z-index: 10000;
}
.countryUl {
}
.countryUl li {
	padding-left: 0.293rem;
	padding-right: 0.293rem;
	line-height: 1.013rem;
	font-size: 0.347rem;
	color: #333333;
	border-bottom: 1px solid #fafafa;
	overflow: hidden;
	.fl {
		float: left;
	}
	.fr {
		float: right;
	}
}
</style>



// WEBPACK FOOTER //
// countryCode.vue?f485b56a